<template>
  <div class="ml-1">
    <h3 class="mt-2 mb-1">
      Creative Type
    </h3>
    <p>
      Choose how you'd like to create your campaign
    </p>
    <b-row>
      <b-col :sm="isModalView ? 6 : 12">
        <div class="card pt-3 pb-1 pl-4 mb-3">
          <b-row class="align-items-center">
            <b-col
              sm="1"
              class="mr-2"
            >
              <input
                id="creativeStudio"
                type="radio"
                :disabled="!GET_IS_CAMPAIGN_DRAFT"
                v-model="creativeType"
                name="creativeType"
                value="CUSTOMISABLE"
                @change="updateCreativeTypeSelected('CUSTOMISABLE')"
              >
            </b-col>
            <b-col sm="2">
              <label for="creativeStudio">
                <i class="fa-kit-duotone fa-creative-studio-icon fa-xl" />
              </label>
            </b-col>
            <b-col sm="8">
              <label for="creativeStudio">
                <h6 class="mb-1">
                  Creative Studio
                </h6>
                <p class="mb-0 small">
                  Design your own custom creatives
                </p>
              </label>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col :sm="isModalView ? 6 : 12">
        <div class="card pt-3 pb-1 pl-4 mb-3">
          <b-row class="align-items-center">
            <b-col
              sm="1"
              class="mr-2"
            >
              <input
                id="uploadOwnCreative"
                :disabled="!GET_IS_CAMPAIGN_DRAFT"
                type="radio"
                v-model="creativeType"
                name="creativeType"
                value="IMAGE"
                @change="updateCreativeTypeSelected('IMAGE')"
              >
            </b-col>
            <b-col sm="2">
              <label for="uploadOwnCreative">
                <i class="fa-kit-duotone fa-upload-own-creative-icon fa-2xl" />
              </label>
            </b-col>
            <b-col sm="8">
              <label for="uploadOwnCreative">
                <h6 class="mb-1">
                  Upload Own Creative
                </h6>
                <p class="mb-0 small">
                  Upload ready-made creatives
                </p>
              </label>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col :sm="isModalView ? 6 : 12">
        <div
          v-if="GET_IS_MANAGED_CAMPAIGN"
          class="card pt-3 pb-1 pl-4 mb-3"
        >
          <b-row class="align-items-center">
            <b-col
              sm="1"
              class="mr-2"
            >
              <input
                id="templateGroup"
                :disabled="!GET_IS_CAMPAIGN_DRAFT"
                type="radio"
                v-model="creativeType"
                name="creativeType"
                value="TEMPLATE_GROUP"
                @change="updateCreativeTypeSelected('TEMPLATE_GROUP')"
              >
            </b-col>
            <b-col sm="2">
              <label for="templateGroup">
                <i class="fa-kit-duotone fa-template-group-icon fa-2xl" />
              </label>
            </b-col>
            <b-col sm="8">
              <label for="templateGroup">
                <h6 class="mb-1">
                  Template Group
                </h6>
                <p class="mb-0 small">
                  Access pre-built templates 
                </p>
              </label>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <hr
        v-if="!isModalView"
        class="mt-2 mb-4"
      >
      <template v-if="creativeType !== 'TEMPLATE_GROUP'">
        <ad-units
          :is-modal-view="isModalView"
        />
      </template>
      <template v-else>
        <b-col :sm="isModalView ? 6 : 12">
          <template-group
            :is-modal-view="isModalView"
            @updateGroup="updateTemplateGroupSelected"
            @updateTemplatesInGroup="updateTemplatesInGroup"
          />
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>

import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import AdUnits from '@/modules/content/components/CreativesPage/Sidebar/CreativeType/AdUnits';
import TemplateGroup from '@/modules/content/components/CreativesPage/Sidebar/CreativeType/TemplateGroup';
import * as contentTypes from '@/modules/content/store/types';
import * as types from '@/store/types';

export default {
  name: 'CreativeType',
  components: {
    TemplateGroup,
    AdUnits,
  },
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      creativeType: 'CUSTOMISABLE',
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'creatives',
      'creativeTypeSelected',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_MANAGED_CAMPAIGN,
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
      campaignTypes.GET_IS_CAMPAIGN_DRAFT,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_CREATIVES_DEFINED,
    ]),
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.PATCH_CAMPAIGN,
    ]),
    ...mapActions('content', [
      contentTypes.PUT_CREATIVES,
      contentTypes.PUT_CREATIVES_WITH_TYPE,
    ]),
    ...mapMutations([
      types.SET_GLOBAL_MESSAGE,
    ]),
    ...mapMutations('campaigns', [
      campaignTypes.CLEAR_CAMPAIGN_TEMPLATE_GROUP,
    ]),
    ...mapMutations('content', [
      contentTypes.SET_CREATIVE_TYPE_SELECTED,
      contentTypes.CLEAR_CREATIVES,
    ]),
    updateCreativeTypeSelected(selectedCreativeType) {
      if (!this.GET_IS_CAMPAIGN_DRAFT) return;
      this.SET_CREATIVE_TYPE_SELECTED(selectedCreativeType);
      if (this.GET_CREATIVES_DEFINED) {
        if (this.creativeType !== 'TEMPLATE_GROUP') {
          this.PUT_CREATIVES_WITH_TYPE();
          this.CLEAR_CAMPAIGN_TEMPLATE_GROUP();
        }
      }
    },
    async updateTemplateGroupSelected(groupWithTemplates) {
      if (!this.GET_IS_CAMPAIGN_DRAFT) return;
      if (!this.creatives || this.creatives.length < 1) return;
      if (this.campaign.templateGroupId === groupWithTemplates.id) return;
      if (groupWithTemplates.templates.length > 0) {
        this.CLEAR_CREATIVES();
        await this.PATCH_CAMPAIGN({ templateGroupId: groupWithTemplates.id });
        await this.PUT_CREATIVES({ creatives: this.buildCreativeRequestList(groupWithTemplates.templates) });
      } else {
        this.SET_GLOBAL_MESSAGE({
          message: `The template group "${groupWithTemplates.name}" doesn't have any templates.`,
          type: 'warning',
        });
      }
    },
    async updateTemplatesInGroup(templates) {
      if (this.GET_IS_CAMPAIGN_READONLY) return;
      this.CLEAR_CREATIVES();
      await this.PUT_CREATIVES({ creatives: this.buildCreativeRequestList(templates) });
    },
    buildCreativeRequestList(templates) {
      return templates.map((template) => ({
        creativeTemplateId: template.id,
        isPaused: !template.selected,
      }));
    },
  },
  created() {
    if (!this.creativeTypeSelected) this.SET_CREATIVE_TYPE_SELECTED(this.creativeType);
    else this.creativeType = this.creativeTypeSelected;
  },
};
</script>
<style scoped lang="scss">
input[type=radio] {
  transform: scale(1.25);
}
.fa-creative-studio-icon {
  --fa-primary-color: #297050;
  --fa-secondary-color: #2AC779;;
}
.fa-upload-own-creative-icon {
  --fa-primary-color: #296673;
  --fa-secondary-color: #2AB2C7;
}
.fa-template-group-icon {
  --fa-primary-color: #293a73;
  --fa-secondary-color: #2A51C7;
}
</style>
